import styled from 'styled-components';

import { Typography } from '@speeki/global-ui-components';

export const ListItem = styled.li`
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding-bottom: 16px;

    &:last-child {
        padding-bottom: 0;
    }
`;

export const ListItemDescription = styled(Typography.TextBody_16_24)`
    padding-left: 13px;
`;
